<template>
  <div style="background-color: #fff;height: 100%;">
    <div style="padding: 20px;">

      <div>
        <el-row v-show="!disabled">
          <el-button type="primary" plain @click.native="toggleModalAdd">添加</el-button>
          <el-button  type="primary" plain @click.native="deleteAll">删除</el-button>
        </el-row>
        <div style="clear: both;"></div>
      </div>

      <div style="height: 10px;"></div>

      <div>
        <template>
          <el-table
            :data="tableData"
            :height="th"
            border
            style="width: 100%;"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="volunteerName" width="200" label="挂钩志愿者"></el-table-column>
            <el-table-column prop="volunteerPhone" width="200" label="联系电话"></el-table-column>
            <el-table-column prop="volunteerAddress" min-width="150" label="家庭住址"></el-table-column>
            <el-table-column fixed="right" label="操作" width="200" v-if="!disabled">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="small"
                  @click="handleEdit(scope.$index, scope.row)"
                >修改</el-button>
                <el-button style="margin-left:20px"
                  type="primary"
                  size="small"
                  @click="handleDelete(scope.row)"
                >删除</el-button>
              </template>
            </el-table-column>
          </el-table>

          <div style="text-align: left;background-color: #fff;padding: 10px;">
            <div
              style="float: left;padding: 5px;"
            >共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
            <div style="float: left;">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="totalItems"
                :page-size="20"
                :current-page.sync="currentPage"  @current-change="current_change"
              ></el-pagination>
            </div>
            <div style="clear: both;"></div>
          </div>
        </template>
      </div>
    </div>
    <HookInfoAdd ref="myHookInfoAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></HookInfoAdd>
    <HookInfoEdit ref="myHookInfoEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></HookInfoEdit>
  </div>
</template>

<script>
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";
import HookInfoAdd from "./HookInfoAdd";
import HookInfoEdit from "./HookInfoEdit"

export default {
  name: "Role",
  data() {
    return {
      showModalAdd: false,
      showModalEdit: false,
      disabled: false,
      tableData: null,
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,
      th: this.$store.state.tableHeight-60,
      userCode: "",
      elderlyCode: "",
      volunteerName: "",
      volunteerPhone: "",
      volunteerAddress: "",
      multipleSelection: [],
      elderlyHelpCodeList:[]
    };
  },
  created() {
    this.th = this.$store.state.tableHeight-90;
  },
  components: {
       HookInfoAdd ,
       HookInfoEdit,
  },
  watch: {
    //监听全局变量
    "$store.state.tableHeight": function (val) {
         this.th = val-90;
    },
    disabled(val){
      this.th = this.$store.state.tableHeight-(val?50:100);
    }
  },
  methods: {
    init(flag,row,disabled){
      if(disabled)this.disabled=disabled
        flag=true;
        this.elderlyCode=row.elderlyCode;
        this.userCode=row.userCode;
        this.getList();
    },
    handleEdit(index, row) {
      this.$refs.myHookInfoEdit.init(row);
      this.showModalEdit = !this.showModalEdit;
    },
    toggleModalAdd: function () {
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myHookInfoAdd.init(this.elderlyCode,this.userCode);
    },
    closeAdd: function () {
      this.showModalAdd = !this.showModalAdd;
    },
    closeEdit: function () {
      this.showModalEdit = !this.showModalEdit;
    },

    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },

    handleDelete(row) {
        this.$confirm('您确定要删除这个志愿者吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios({
        method: "post",
        url: this.$shopUrl + "EElderlyHelp/Delete",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          elderlyHelpCode: row.elderlyHelpCode
        },
      })
        .then((response) => {
          console.log(response);
          if (response.data.error == 0) {
            this.$message({
            type: 'success',
            message: '删除成功!',
          });
            this.getList();
          } else if (response.data.error == 1) {
            this.$message.error(response.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

    },



     deleteAll() {
        this.$confirm('您确定要删除所选志愿者吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if(this.multipleSelection.length==0){
            this.$message({
            type: 'warning',
            message: '您没有选择志愿者!',
          });
          return
          }
        this.elderlyHelpCodeList=[];
        this.multipleSelection.forEach(element => {
                            this.elderlyHelpCodeList.push(element.elderlyHelpCode);
                            }),
        this.$axios({
        method: "post",
        url: this.$shopUrl + "EElderlyHelp/DeleteAll",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          elderlyHelpCodeList: this.elderlyHelpCodeList
        },
      })
        .then((response) => {
          console.log(response);
          if (response.data.error == 0) {
             this.$message({
            type: 'success',
            message: '删除成功!',
          });
            this.getList();
          } else if (response.data.error == 1) {
            this.$message.error(response.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

    },

    getList(flag) {
      if(flag)this.currentPage=1
      this.$axios({
        method: "post",
        url: this.$shopUrl + "EElderlyHelp/Page",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          pageIndex: this.currentPage,
          elderlyCode: this.elderlyCode,
          userCode: this.userCode,
          pageSize: this.pageSize,
        },
      })
        .then((response) => {
          console.log(response);
          if (response.data.error == 0) {
            this.tableData = response.data.data.list;
            this.totalItems = response.data.data.total;
          } else if (response.data.error == 1) {
            this.$message.error(response.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

  },
};
</script>

<style scoped>

</style>
